const RangeAnalyses = (props) => {
  let item = props.item;
  // {
  //   type: "Skeletal",
  //   title: "SNA",
  //   startPoint: "S",
  //   middlePoint: "N",
  //   endPoint: "A",
  //   isShow: true,
  //   color: "blue",
  //   marginPixelFromCenter: 20,
  //   LowerNormalValue: 80,
  //   UpperNormalValue: 120,
  //   marginValue: 20,
  //   AccualValue: 90,
  //    stepRuller: 1,
  // },
  const AccualValue = item?.AccualValue;
  const LowerNormalValue = item?.LowerNormalValue;
  const UpperNormalValue = item?.UpperNormalValue;
  const MarginValue = item?.marginValue;

  let StartValue = item?.LowerNormalValue - item?.marginValue;
  let EndValue = item?.UpperNormalValue + item?.marginValue;

  // if (AccualValue > EndValue) {
  //   EndValue = AccualValue;
  // }

  // if (AccualValue < StartValue) {
  //   StartValue = AccualValue;
  // }

  const WholeRenge = EndValue - StartValue;
  const NormalRenge = UpperNormalValue - LowerNormalValue;

  const offsetX = 10;
  const Wsize = 100;
  const Hsize = 40;

  const AngleOnSize = (EndValue - StartValue) / Wsize;
  const SizeOnAngle = 1 / AngleOnSize;

  const stepRuller = item?.stepRuller;
  const stepCount = WholeRenge / stepRuller;

  const _returnStep = () => {
    let _outPut = [];

    for (let index = 0; index < stepCount; index++) {
      _outPut.push(
        <line
          x1={offsetX + index * stepRuller * SizeOnAngle}
          y1={20}
          x2={offsetX + index * stepRuller * SizeOnAngle}
          y2={22}
          stroke="black"
          stroke-width="1"
        />
      );
    }

    _outPut.push(
      <>
        <line
          x1={offsetX + MarginValue * SizeOnAngle}
          y1={20}
          x2={offsetX + MarginValue * SizeOnAngle}
          y2={28}
          stroke="black"
          stroke-width="1"
        />
        <line
          x1={offsetX + (MarginValue + NormalRenge) * SizeOnAngle}
          y1={20}
          x2={offsetX + (MarginValue + NormalRenge) * SizeOnAngle}
          y2={28}
          stroke="black"
          stroke-width="1"
        />
        <text
          className="textStyleRangeComponent"
          text-anchor="middle"
          x={offsetX + MarginValue * SizeOnAngle}
          y={40}
          fill="green"
        >
          {LowerNormalValue}°
        </text>
        <text
          className="textStyleRangeComponent"
          text-anchor="middle"
          x={offsetX + (MarginValue + NormalRenge) * SizeOnAngle}
          y={40}
          fill="green"
        >
          {UpperNormalValue}°
        </text>
      </>
    );

    return _outPut;
  };

  const _returnActualValue = () => {
    let _outPut = [];
    let x_actual = offsetX + (AccualValue - StartValue) * SizeOnAngle;
    let y_actual = Hsize / 2;
    let TraingleHeadPoint = x_actual.toString() + "," + y_actual.toString();
    let leftPOint = " " + (x_actual - 5).toString() + ",5 ";
    let rightPOint = " " + (x_actual + 5).toString() + ",5";
    let points = TraingleHeadPoint + leftPOint + rightPOint;
    let color = "green";

    if (AccualValue < LowerNormalValue || AccualValue > UpperNormalValue) {
      color = "red";
    }

    _outPut.push(<polygon points={points} style={{ fill: color }} />);
    _outPut.push(
      <line
        x1={x_actual}
        y1={20}
        x2={x_actual}
        y2={26}
        stroke={color}
        stroke-width="1"
      />
    );
    _outPut.push(
      <text
        className="textStyleRangeComponent"
        style={{ fill: color }}
        x={x_actual + 5}
        y={12}
      >
        {AccualValue}°
      </text>
    );

    return _outPut;
  };

  return (
    <div style={{ marginLeft: 20 }}>
      <svg width={Wsize + 2 * offsetX} height={Hsize}>
        {_returnStep()}
        <line
          x1={0 + offsetX}
          y1={20}
          x2={Wsize + offsetX}
          y2={20}
          stroke="black"
          stroke-width="1"
        />
        <line
          x1={0 + offsetX}
          y1={18}
          x2={0 + offsetX}
          y2={22}
          stroke="black"
          stroke-width="1"
        />
        <line
          x1={Wsize + offsetX}
          y1={18}
          x2={Wsize + offsetX}
          y2={22}
          stroke="black"
          stroke-width="1"
        />
        <rect
          width={NormalRenge * SizeOnAngle}
          height="10"
          x={offsetX + MarginValue * SizeOnAngle}
          y={"10"}
          fill="#87d068"
        />
        <text
          className="textStyleRangeComponent"
          text-anchor="middle"
          x={offsetX}
          y={40}
        >
          {StartValue}°
        </text>

        <text
          className="textStyleRangeComponent"
          text-anchor="middle"
          x={Wsize + offsetX}
          y={40}
        >
          {EndValue}°
        </text>
        {_returnActualValue()}
      </svg>
    </div>
  );
};

export default RangeAnalyses;
